import { useState } from 'react';
import styles from '../styles/styles.module.css';
import AddUser from './AddUser';
import { IoArrowBackCircle } from 'react-icons/io5';
import { FaPlusCircle } from 'react-icons/fa';
import Users from './Users';
import { useSelector } from 'react-redux';

const UserSetup = () => {
  const [addUserActive, setAddUserActive] = useState(false);
  const { sitePermissions, companyPermissions, userType } = useSelector(
    (state: any) => state.user
  );

  function canEnroll() {
    if (userType === 'HYPER_ADMIN' || userType === 'COMPANY_ADMIN') {
      return true;
    }
    if (sitePermissions.enrollUsers) {
      return true;
    }
    if (companyPermissions.enrollUsers) {
      return true;
    }
    return false;
  }

  function handleAddClick() {
    setAddUserActive(!addUserActive);
  }

  return (
    <div className={styles.subPageWrapper}>
      <div onClick={handleAddClick} className={styles.addSiteButton}>
        {addUserActive ? (
          <div className={styles.addSite}>
            <IoArrowBackCircle className={styles.backArrow} />
            <p className={styles.addNewTextBack}>Go Back</p>
          </div>
        ) : (
          <div className={styles.addSite}>
            {canEnroll() && (
              <>
                <FaPlusCircle className={styles.plusSymbol} />
                <p className={styles.addNewText}>Add New User</p>
              </>
            )}
          </div>
        )}
      </div>
      {addUserActive ? (
        <AddUser setAddUserActive={setAddUserActive} />
      ) : (
        <Users />
      )}
    </div>
  );
};

export default UserSetup;
